var Agitavit;
(function (Agitavit) {
    var Controls;
    (function (Controls) {
        var Operator;
        (function (Operator) {
            Operator[Operator["Equal"] = 1] = "Equal";
            Operator[Operator["NotEqual"] = 2] = "NotEqual";
        })(Operator = Controls.Operator || (Controls.Operator = {}));
        /**
         * Common utilities for controls.
         */
        var Utilities = /** @class */ (function () {
            function Utilities() {
            }
            Utilities.removeValidationRules = function (element) {
                var $element = $(element).find("[data-val]");
                $element.attr("data-rule-required", "false");
                $element.attr("accept", "false");
                $element.attr("maxsize", "false");
                $element.attr("defaultLanguage", "false");
                $element.attr("data-rule-date", "false");
                this.parseFormValidationRules($element.closest("form"));
            };
            Utilities.addValidationRule = function (element, rule, args) {
                var $element = $(element);
                // nOTE: when adding new validation rules, don"t forget to remove them in "removeValidationRules" function as well
                if (rule === "required") {
                    $element.attr("data-val", "true");
                    $element.attr("data-rule-required", "true");
                }
                else if (rule === "accept" && args) {
                    $element.attr("accept", args);
                    $element.attr("data-rule-accept", args);
                    $element.attr("data-msg-accept", Agitavit.Utilities.localizeResourceKey("AgDbFile_FileType_Error"));
                }
                else if (rule === "maxsize" && args) {
                    $element.attr("maxsize", "true");
                    $element.attr("data-rule-maxsize", args);
                    $element.attr("data-msg-maxsize", Utilities.format(Agitavit.Utilities.localizeResourceKey("AgDbFile_MaxSize_Error"), [args]));
                }
                else if (rule === "date") {
                    $element.attr("data-val", "true");
                    $element.attr("data-rule-date", "true");
                }
                else if (rule === "defaultLanguage") {
                    $element.attr("defaultLanguage", "true");
                    $element.attr("data-rule-defaultLanguage", args);
                    $element.attr("data-msg-defaultLanguage", Utilities.format(Agitavit.Utilities.localizeResourceKey("AgDbMultilang_DefaultLanguageRequired_Error"), [args]));
                }
                else {
                    throw new Error("Unsupported validation rule.");
                }
                this.parseFormValidationRules($element.closest("form"));
            };
            Utilities.parseFormValidationRules = function (form) {
                if (!Utilities._reloadValidationRulesScheduled) {
                    Utilities._reloadValidationRulesScheduled = true;
                    $(function () {
                        Utilities.parseFormValidationRulesImpl2(form);
                    });
                }
                Utilities.parseFormValidationRulesImpl(form);
            };
            Utilities.parseFormValidationRulesImpl = function (form) {
                var validator = form.data("validator");
                if (validator) {
                    validator.destroy();
                }
                form.removeData("validator");
                form.removeData("unobtrusiveValidation");
                $.validator.unobtrusive.parse(form);
            };
            Utilities.parseFormValidationRulesImpl2 = function (form) {
                Utilities._reloadValidationRulesScheduled = false;
                form.removeData("validator");
                form.removeData("unobtrusiveValidation");
                $.validator.unobtrusive.parse(form);
            };
            Utilities.calculateResponsiveGridLayout = function (columns) {
                var layout = [{ min: 0, columns: [] }];
                var priorities = {};
                var baseWidth = 0;                              
                var isPercent = columns.some(function (c) { return String(c.ColumnMinWidth).indexOf("%") !== -1 || String(c.ColumnWidth).indexOf("%") !== -1; });
                if (isPercent) {
                    columns.forEach(function (c) {
                        if (c.IsHidden) {
                            return;
                        }
                        else {
                            layout[0].columns.push(c.BaseName);
                        }
                    });
                    return {
                        minWidth: 0,
                        layout: layout
                    };
                }
                else {                 
                    // distribute columns into priority buckets
                    columns.forEach(function (c) {
                        if (c.IsHidden) {
                            return;
                        }

                        if ($.agito.isMobileDevice || $.agito.isMobileApp) {
                            c.ColumnMinWidth = null;
                            c.ColumnWidth = null;
                        }


                        if (c.ColumnPriority)
                        {
                            var mobile = ($.agito.isMobileDevice || $.agito.isMobileApp);

                            if (mobile && c.ColumnPriority == 1) {
                                c.IsHidden = true;
                                return;
                            }

                            if (!mobile && c.ColumnPriority == 2) {
                                c.IsHidden = true;
                                return;
                            }

                            var priorityKey = c.ColumnPriority.toString();
                            var priority = { col: c.BaseName, width: Number(c.ColumnMinWidth) || Number(c.ColumnWidth) || 150 };
                            if (!priorities[priorityKey]) {
                                priorities[priorityKey] = [priority];
                            }
                            else {
                                priorities[priorityKey].push(priority);
                            }
                        }
                        else {
                            baseWidth += Number(c.ColumnMinWidth) || Number(c.ColumnWidth) || 150;
                            layout[0].columns.push(c.BaseName);
                        }
                    });
                    var cols_1 = layout[0].columns;
                    var minWidth = baseWidth;
                    // calculate min widths and columns for priority buckets
                    Object.keys(priorities).sort().forEach(function (priority) {
                        cols_1 = cols_1.slice();
                        priorities[priority].forEach(function (col) {
                            baseWidth += col.width;
                            cols_1.push(col.col);
                        });
                        layout.push({ min: baseWidth, columns: cols_1 });
                    });
                    return {
                        minWidth: minWidth,
                        layout: layout
                    };
                }
            };
            
            Utilities.convertIgFilterToJsonExpression = function (igExpressions, formats) {
                var filters = [];
                if (!igExpressions || igExpressions.length === 0) { // ![] == false
                    return filters;
                }
                igExpressions.forEach(function (expr) {
                    var format = (!formats || formats.length === 0) ? null : formats.find(function (f) { return f.columnName == expr.fieldName; }).format;
                    var dataType = (!formats || formats.length === 0) ? null : formats.find(function (f) { return f.columnName == expr.fieldName; }).dataType;
                    if (expr.cond === "true" && expr.expr == null) {
                        // workaround for IG always filtering on boolean columns (expr is non-null when actual filtering on boolean column is requested).
                        return;
                    }

                    var filter = dataType == 'multilang' ?
                        {
                            LeftExpr: {
                                LocalizeExpression: { ColumnPath: expr.fieldName }
                            },
                            RightExpr: { ConstantValue: expr.expr }
                        } : 
                        {
                            LeftExpr: { ColumnPath: expr.fieldName },
                            RightExpr: { ConstantValue: expr.expr }
                        };
                    switch (expr.cond) {
                        case "startsWith":
                            filter.Operator = "StartsWith";
                            break;
                        case "endsWith":
                            filter.Operator = "EndsWith";
                            break;
                        case "contains":
                            filter.Operator = "Contains";
                            break;
                        case "doesNotContain":
                            filter.Operator = "NotContains";
                            break;
                        case "equals":
                            filter.Operator = "Equal";
                            break;
                        case "doesNotEqual":
                            filter.Operator = "NotEqual";
                            break;
                        case "null":
                            filter.RightExpr = { PredefinedValue: "Null" };
                            filter.Operator = "Equal";
                            break;
                        case "notNull":
                            filter.RightExpr = { PredefinedValue: "Null" };
                            filter.Operator = "NotEqual";
                            break;
                        case "empty":
                            if (format === "Agitavit.Controls.AgBooleanControl" || format === "Agitavit.Controls.AgNumericControl") {
                                filter.RightExpr = { PredefinedValue: "Null" };
                                filter.Operator = "Equal";
                            }
                            else {
                                filter = {
                                    Operator: "Or",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { PredefinedValue: "Null" },
                                            Operator: "Equal"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: "" },
                                            Operator: "Equal"
                                        }
                                    ]
                                };
                            }
                            break;
                        case "notEmpty":
                            if (format === "Agitavit.Controls.AgBooleanControl" || format === "Agitavit.Controls.AgNumericControl") {
                                filter.RightExpr = { PredefinedValue: "Null" };
                                filter.Operator = "NotEqual";
                            }
                            else {
                                filter = {
                                    Operator: "And",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { PredefinedValue: "Null" },
                                            Operator: "NotEqual"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: "" },
                                            Operator: "NotEqual"
                                        }
                                    ]
                                };
                            }
                            break;
                        case "greaterThan":
                        case "after":
                            filter.Operator = "Greater";
                            break;
                        case "lessThan":
                        case "before":
                            filter.Operator = "Less";
                            break;
                        case "greaterThanOrEqualTo":
                            filter.Operator = "GreaterOrEqual";
                            break;
                        case "lessThanOrEqualTo":
                            filter.Operator = "LessOrEqual";
                            break;
                        case "true":
                            filter.RightExpr = { ConstantValue: true };
                            filter.Operator = "Equal";
                            break;
                        case "false":
                            filter.RightExpr = { ConstantValue: false };
                            filter.Operator = "Equal";
                            break;
                        case "today":
                            filter = {
                                Operator: "And",
                                Conditions: [
                                    {
                                        LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "Year" } },
                                        RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "Year" } },
                                        Operator: "Equal"
                                    },
                                    {
                                        LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "DayOfYear" } },
                                        RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "DayOfYear" } },
                                        Operator: "Equal"
                                    }
                                ]
                            };
                            break;
                        case "yesterday":
                            filter = {
                                Operator: "And",
                                Conditions: [
                                    {
                                        LeftExpr: {
                                            DatePart: {
                                                Date: {
                                                    DateAdd: { Date: { ColumnPath: expr.fieldName }, Amount: { ConstantValue: 1 }, Unit: "Day" }
                                                },
                                                Unit: "Year"
                                            }
                                        },
                                        RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "Year" } },
                                        Operator: "Equal"
                                    },
                                    {
                                        LeftExpr: {
                                            DatePart: {
                                                Date: {
                                                    DateAdd: { Date: { ColumnPath: expr.fieldName }, Amount: { ConstantValue: 1 }, Unit: "Day" }
                                                },
                                                Unit: "DayOfYear"
                                            }
                                        },
                                        RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "DayOfYear" } },
                                        Operator: "Equal"
                                    }
                                ]
                            };
                            break;
                        case "thisMonth":
                            var date = new Date();
                            var currentMonthStart = new Date(date.getFullYear(), date.getMonth(), 1);
                            var nextMonthStart = new Date(currentMonthStart);
                            nextMonthStart.setMonth(nextMonthStart.getMonth() + 1);

                            currentMonthStart.setHours(0);
                            currentMonthStart.setMinutes(0);
                            currentMonthStart.setSeconds(0);
                            currentMonthStart.setMilliseconds(0);

                            nextMonthStart.setHours(0);
                            nextMonthStart.setMinutes(0);
                            nextMonthStart.setSeconds(0);
                            nextMonthStart.setMilliseconds(0);

                            filter = {
                                Operator: "And",
                                Conditions: [
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: currentMonthStart },
                                        Operator: "GreaterOrEqual"
                                    },
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: nextMonthStart },
                                        Operator: "Less"
                                    }
                                ]
                            };
                            break;
                        case "lastMonth":
                            var date = new Date();
                            var currentMonthStart = new Date(date.getFullYear(), date.getMonth(), 1);
                            var lastMonthStart = new Date(currentMonthStart);
                            lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

                            currentMonthStart.setHours(0);
                            currentMonthStart.setMinutes(0);
                            currentMonthStart.setSeconds(0);
                            currentMonthStart.setMilliseconds(0);

                            lastMonthStart.setHours(0);
                            lastMonthStart.setMinutes(0);
                            lastMonthStart.setSeconds(0);
                            lastMonthStart.setMilliseconds(0);

                            filter = {
                                Operator: "And",
                                Conditions: [
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: lastMonthStart },
                                        Operator: "GreaterOrEqual"
                                    },
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: currentMonthStart },
                                        Operator: "Less"
                                    }
                                ]
                            };
                            break;
                        case "nextMonth":
                            var date = new Date();
                            var currentMonthStart = new Date(date.getFullYear(), date.getMonth(), 1);
                            var nextMonthStart = new Date(currentMonthStart);
                            nextMonthStart.setMonth(nextMonthStart.getMonth() + 1);
                            var nextSecondMonthStart = new Date(nextMonthStart);
                            nextSecondMonthStart.setMonth(nextSecondMonthStart.getMonth() + 1);

                            nextMonthStart.setHours(0);
                            nextMonthStart.setMinutes(0);
                            nextMonthStart.setSeconds(0);
                            nextMonthStart.setMilliseconds(0);

                            nextSecondMonthStart.setHours(0);
                            nextSecondMonthStart.setMinutes(0);
                            nextSecondMonthStart.setSeconds(0);
                            nextSecondMonthStart.setMilliseconds(0);

                            filter = {
                                Operator: "And",
                                Conditions: [
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: nextMonthStart },
                                        Operator: "GreaterOrEqual"
                                    },
                                    {
                                        LeftExpr: { ColumnPath: expr.fieldName },
                                        RightExpr: { ConstantValue: nextSecondMonthStart },
                                        Operator: "Less"
                                    }
                                ]
                            };
                            break;
                        case "thisYear":
                            filter = {
                                LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "Year" } },
                                RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "Year" } },
                                Operator: "Equal"
                            };
                            break;
                        case "lastYear":
                            filter = {
                                LeftExpr: {
                                    DatePart: {
                                        Date: { DateAdd: { Date: { ColumnPath: expr.fieldName }, Amount: { ConstantValue: 1 }, Unit: "Year" } },
                                        Unit: "Year"
                                    }
                                },
                                RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "Year" } },
                                Operator: "Equal"
                            };
                            break;
                        case "nextYear":
                            filter = {
                                LeftExpr: {
                                    DatePart: {
                                        Date: { DateAdd: { Date: { ColumnPath: expr.fieldName }, Amount: { ConstantValue: -1 }, Unit: "Year" } },
                                        Unit: "Year"
                                    }
                                },
                                RightExpr: { DatePart: { Date: { GetDate: "Local" }, Unit: "Year" } },
                                Operator: "Equal"
                            };
                            break;
                        case "on":
                            if (format == "Agitavit.Controls.AgDateControl") {
                                // calculate interval
                                var dateStart = new Date(new Date(new Date(new Date(new Date(expr.expr).setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0));
                                var dateEnd = new Date(dateStart.getTime() + (24 * 60 * 60 * 1000));
                                filter = {
                                    Operator: "And",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateStart },
                                            Operator: "GreaterOrEqual"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateEnd },
                                            Operator: "Less"
                                        }
                                    ]
                                };
                            }
                            else if (format == "Agitavit.Controls.AgDateTimeControl") {
                                // calculate interval
                                var timeZoneOffset = new Date(expr.expr).getTimezoneOffset();
                                var dateStart = new Date(new Date(new Date(new Date(expr.expr).setSeconds(0)).setMilliseconds(0)).getTime() + timeZoneOffset * 60 * 1000);
                                var dateEnd = new Date(dateStart.getTime() + (1 * 60 * 1000));
                                filter = {
                                    Operator: "And",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateStart.toISOString() },
                                            Operator: "GreaterOrEqual"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateEnd.toISOString() },
                                            Operator: "Less"
                                        }
                                    ]
                                };
                            }
                            else {
                                filter = {
                                    Operator: "And",
                                    Conditions: [
                                        {
                                            LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "Year" } },
                                            RightExpr: { DatePart: { Date: { ConstantValue: expr.expr }, Unit: "Year" } },
                                            Operator: "Equal"
                                        },
                                        {
                                            LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "DayOfYear" } },
                                            RightExpr: { DatePart: { Date: { ConstantValue: expr.expr }, Unit: "DayOfYear" } },
                                            Operator: "Equal"
                                        }
                                    ]
                                };
                            }
                            break;
                        case "notOn":
                            if (format == "Agitavit.Controls.AgDateControl") {
                                // calculate interval
                                var dateStart = new Date(new Date(new Date(new Date(expr.expr.setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0));
                                var dateEnd = new Date(dateStart.getTime() + (24 * 60 * 60 * 1000));
                                filter = {
                                    Operator: "Or",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateStart },
                                            Operator: "Less"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateEnd },
                                            Operator: "GreaterOrEqual"
                                        }
                                    ]
                                };
                            }
                            else if (format == "Agitavit.Controls.AgDateTimeControl") {
                                // calculate interval
                                var timeZoneOffset = new Date(expr.expr).getTimezoneOffset();
                                var dateStart = new Date(new Date(new Date(new Date(expr.expr).setSeconds(0)).setMilliseconds(0)).getTime() + timeZoneOffset * 60 * 1000);
                                var dateEnd = new Date(dateStart.getTime() + (1 * 60 * 1000));
                                filter = {
                                    Operator: "Or",
                                    Conditions: [
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateStart.toISOString() },
                                            Operator: "Less"
                                        },
                                        {
                                            LeftExpr: { ColumnPath: expr.fieldName },
                                            RightExpr: { ConstantValue: dateEnd.toISOString() },
                                            Operator: "GreaterOrEqual"
                                        }
                                    ]
                                };
                            }
                            else {
                                filter = {
                                    Operator: "Or",
                                    Conditions: [
                                        {
                                            LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "Year" } },
                                            RightExpr: { DatePart: { Date: { ConstantValue: expr.expr }, Unit: "Year" } },
                                            Operator: "NotEqual"
                                        },
                                        {
                                            LeftExpr: { DatePart: { Date: { ColumnPath: expr.fieldName }, Unit: "DayOfYear" } },
                                            RightExpr: { DatePart: { Date: { ConstantValue: expr.expr }, Unit: "DayOfYear" } },
                                            Operator: "NotEqual"
                                        }
                                    ]
                                };
                            }
                            break;
                        default:
                            throw new Error("Unsupported condition.");
                    }
                    filters.push(JSON.stringify(filter));
                });
                return filters;
            };
            Utilities.format = function (string, object) {
                return string.replace(/{([^{}]*)}/g, function (match, group_match) {
                    var data = object[group_match];
                    return typeof data === "string" ? data : match;
                });
            };
            Utilities.checkElementAttribute = function (firstEl, secondEl, attribute, operator) {
                switch (operator) {
                    case (Operator.Equal): {
                        return firstEl.attr(attribute) === secondEl.attr(attribute);
                    }
                    case (Operator.NotEqual): {
                        return firstEl.attr(attribute) != secondEl.attr(attribute);
                    }
                    default: {
                        return false;
                    }
                }
            };
            Utilities._reloadValidationRulesScheduled = false;
            return Utilities;
        }());
        Controls.Utilities = Utilities;
    })(Controls = Agitavit.Controls || (Agitavit.Controls = {}));
})(Agitavit || (Agitavit = {}));
(function (Agitavit) {
    var Controls;
    (function (Controls) {
        var IgGridControl;
        (function (IgGridControl) {
            var Formatters;
            (function (Formatters) {
                function boolFormatter(columnName) {
                    return function (val, row) {
                        if (val === true) {
                            return $.agito.resources.getResource("Common_Grid_Boolean_Yes");
                        }
                        else if (val === false) {
                            return $.agito.resources.getResource("Common_Grid_Boolean_No");
                        }
                        else {
                            return "";
                        }
                    };
                }
                Formatters.boolFormatter = boolFormatter;
                function textFormatter(columnName) {
                    return function (val, row) {
                        val = row[columnName] ? row[columnName] : val;
                        return $.ig.encode(val || "");
                    };
                }
                Formatters.textFormatter = textFormatter;
                function multilangFormatter(columnName) {
                    return function (val, row) {
                        if (row && val && Agitavit.Utilities.selectedLanguage) {
                            var json = row[columnName] ? row[columnName] : val;
                            var translatedVal = JSON.parse(json)[Agitavit.Utilities.selectedLanguage];
                            if (!translatedVal || translatedVal.length === 0) {
                                translatedVal = JSON.parse(json)[Agitavit.Utilities.defaultLanguage];
                            }
                            return $.ig.encode(translatedVal);
                        }
                        return "";
                    };
                }
                Formatters.multilangFormatter = multilangFormatter;
                function comboFormatter(columnName) {
                    return function (val, row) {
                        if (row[columnName].Value) {
                            return row[columnName].Value.Name || "";
                        }
                        else {
                            return row[columnName].Name || "";
                        }
                    };
                }
                Formatters.comboFormatter = comboFormatter;
                function thousandFormatter(columnName) {
                    return function (val, row) {
                        var ig = $.ig;
                        var thousandSeparator = ig.regional.defaults.numericGroupSeparator;
                        if (val) {
                            return ig.formatter(val, "number", "double").split(thousandSeparator).join("");
                        }
                        else {
                            return "";
                        }
                    };
                }
                Formatters.thousandFormatter = thousandFormatter;
                thousandFormatter.groupSeparator = "";
                function twoDecimalsFormatter(columnName) {
                    return function (val, row) {
                        var ig = $.ig;
                        if (val) {
                            return ig.formatter(val, "number", "0.00");
                        }
                        else {
                            return "";
                        }
                    };
                }
                Formatters.twoDecimalsFormatter = twoDecimalsFormatter;
            })(Formatters = IgGridControl.Formatters || (IgGridControl.Formatters = {}));
        })(IgGridControl = Controls.IgGridControl || (Controls.IgGridControl = {}));
    })(Controls = Agitavit.Controls || (Agitavit.Controls = {}));
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=utilities.js.map